// index.tsx
import React, { useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface"; // Ensure correct path

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  selectedRowKeys: controlledKeys,
  onSelectionChange,
}) => {
  const [internalKeys, setInternalKeys] = useState<any[]>([]);

  // Controlado quando a página passa selectedRowKeys; senão usa estado interno
  const isControlled = controlledKeys !== undefined;
  const selectedRowKeys = isControlled ? controlledKeys : internalKeys;

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    if (!isControlled) {
      setInternalKeys(newSelectedRowKeys);
    }
    onSelectionChange?.(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Table
      className="table datanew dataTable no-footer"
      rowSelection={rowSelection}
      columns={columns}
      dataSource={dataSource}
       // Assuming `id` is the unique identifier of each record
    />
  );
};

export default Datatable;
